export default __webpack_public_path__ + "static/media/HP.0709c9a0.png";